import React, { useState } from "react";
import { Layout } from "antd";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { UserTypeAtom, UserType } from "../../atom/user.atom";
import { useRecoilState } from "recoil";
import AuthService from "../../services/auth.service";
import { Image } from "antd";
import axios from "axios"; // axios 추가
import "popper.js";
import "jquery";
import { useNavigate } from "react-router-dom";
import media from "../styles/media";
import { Select } from "antd";
import { API_BASE_URL } from "../../services/apiConfig";

const { Header } = Layout;
const { Option } = Select;
const headerStyle: React.CSSProperties = {
  backgroundColor: "#123758",
};
interface ClubInfo {
  club_seq: number;
  club_name: string;
  valid: boolean;
  club_category_seq: number;
  agentSeq: number;
}
interface HeadersProps {
  selectclub: any;
  selectedDeviceName: any;
  selectedDeviceName1: any;
  selectedchangeroom: boolean;
  selectedValue: number;
  clubdata: any;
  profiledata: any;
  onSelectClick: (value: string) => void; // Add this line
  onClubInfoSelect: (clubInfo: ClubInfo | null) => void;
  onselectedchangeroom: (selectedchangeroom: boolean) => void;
  selectedDeviceall: any;
  selectmemberidsoket: any;
}
export default function Headers({
  onSelectClick,
  selectedValue,
  selectclub,
  clubdata,
  profiledata,
  selectedDeviceName,
  selectedDeviceName1,
  selectedchangeroom,
  selectmemberidsoket,
  onselectedchangeroom,
  selectedDeviceall,
  onClubInfoSelect,
}: HeadersProps) {
  const [clubNameList, setClubNameList] = useState<string[]>([]);
  const [width, setWidth] = useState(window.innerWidth);
  const [selectedOption, setSelectedOption] = useState<string>();
  const [selectdid, setselectdid] = useState<string>("");
  const [selectmemberid, setselectmemberid] = useState<string>("");
  const [selectdeviceid, setselectdeviceid] = useState<string>("");
  const [selectagent_seq, setselectagent_seq] = useState<number>(0);
  const [token, settoken] = useState<string | null>(null);
  const [selectclub_seq, setselectclub_seq] = useState<string>("");
  const [userAtom, setUserAtom] = useRecoilState<UserType>(UserTypeAtom);
  const [profileImage, setProfileImage] = useState<string | null>(null);
  const [SelectValue, setSelectValue] = useState("라임카드를 선택해주세요"); // 초기값 설정
  const [waitview, setwaitview] = useState<Window | null>(null);
  const [waitinput, setwaitinput] = useState<Window | null>(null);

  useEffect(() => {
    // console.log("(header) 트리거:" + selectedchangeroom);
    localStorage.setItem("isroomchange", (!selectedchangeroom).toString()); // localStorage에 값 저장
  }, [selectedchangeroom]); // selectedchangeroom을 의존성 배열에 추가

  useEffect(() => {
    if (token !== null && selectedDeviceName !== undefined) {
      // console.log("(headers) 접수대기 지금 선택중인 진료과 : " + selectedDeviceName)
      // console.log("(headers) 접수대기 지금 선택중인 진료과2 : " + selectedDeviceall)
      if (selectedDeviceall) {

        const devices = JSON.parse(selectedDeviceall);

        // 선택된 값과 동일한 deviceId를 필터링하여 가져오기
        const matchingDeviceIds: string[] = devices
          .filter((item: any) => item.deviceName === selectedDeviceName)
          .map((item: any) => item.deviceId);

        // 결과 출력
        // console.log("선택된 값과 동일한 deviceId:", matchingDeviceIds);
        setselectdeviceid(matchingDeviceIds.toString());
      }
    }
  }, [selectedDeviceName]);
  useEffect(() => {
    if (token !== null && selectedDeviceName1 !== undefined) {
      // console.log("(headers) 접수 지금 선택중인 진료과 : " + selectedDeviceName1)
    }
  }, [selectedDeviceName1]);
  useEffect(() => {
    if (token != null) {
      // console.log("(headers)내 클럽 list : " + JSON.stringify(clubdata,null,2))
      const clubNames = clubdata.map((club: any) => club.club_name);
      setClubNameList(["라임카드를 선택해주세요", ...clubNames])
    }
  }, [clubdata]);
  useEffect(() => {
    if (token != null) {
      // console.log("클럽 이름 목록:", clubNameList);
    }
  }, [clubNameList]);
  useEffect(() => {
    let selectedValue = "";
    if (token != null) {
      // console.log("(header) : 클럽 " + selectclub + "이(가) 클릭되었습니다.");
      // console.log("클럽변경")
      selectedValue = selectclub;


      if (selectedValue.toString().includes("#@#@")) {
        const trimmedValue = selectedValue.substring(0, selectedValue.length - 4);
        selectedValue = trimmedValue;
        setSelectValue(trimmedValue);
      } else {
        setSelectValue(selectedValue);
      }
      if (selectedValue !== "라임카드를 선택해주세요") {



        const clubInfo = clubdata.find(
          (club: any) => club.club_seq === parseInt(selectedValue, 10)
        );
        if (clubInfo) {
          onClubInfoSelect({
            club_seq: clubInfo.club_seq,
            club_name: clubInfo.club_name,
            valid: clubInfo.valid,
            club_category_seq: clubInfo.club_category_seq,
            agentSeq: clubInfo.agentSeq,
          });
          setselectagent_seq(clubInfo.agentSeq)
          setselectclub_seq(clubInfo.club_seq);

          setSelectValue(clubInfo.club_name)
        } else {
          onClubInfoSelect({
            club_seq: 0,
            club_name: "",
            valid: false,
            club_category_seq: 0,
            agentSeq: 0,
          });
          setselectagent_seq(0);
        }
      } else {
        onClubInfoSelect({
          club_seq: 0,
          club_name: "",
          valid: false,
          club_category_seq: 0,
          agentSeq: 0,
        });
        setselectagent_seq(0);
      }

    }
  }, [selectclub]);


  useEffect(() => {
    if (token !== null) {
      // console.log("선택한 클럽의 agent_seq" + selectagent_seq)
    }
  }, [selectagent_seq]);

  useEffect(() => {
    if (token !== null) {
      const user = AuthService.getCurrentToken();
      if (!user) {
        logOut();
        return;
      }
      const userId = AuthService.getCurrentUserId();
      if (!!!userId?.trim()) {
        logOut();
        return;
      }
    }
  }, [token]);



  useEffect(() => {
    if (token !== null) {
      // console.log("(header) 프로필조회 " + JSON.stringify(profiledata,null,2))
      const profileData = profiledata;

      // console.log("이슈어이미지 확인"+profileData[0].profileFilePath)
      // console.log("이슈어did 확인"+profileData[0].memberDid)
      // console.log("이슈어맴버아이디 확인"+profileData[0].memberId)

      setProfileImage(profileData[0].profileFilePath);
      setselectdid(profileData[0].memberDid);
      setselectmemberid(profileData[0].memberId);
    }
  }, [profiledata]);


  const onSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    setSelectedOption(value);
    onSelectClick(value); // 이 부분에서 직접 value를 전달하도록 수정
  };

  useEffect(() => {
    const rawToken = AuthService.getRawToken();
    settoken(rawToken);
  }, []);

  useEffect(() => {
    // setSelectedOption(null);
    onSelectChange({
      target: { value: "" },
    } as React.ChangeEvent<HTMLSelectElement>);
  }, []);
  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  const handleSelectChange = (event: any) => {
    // console.log("클럽변경")
    const selectedValue = event.target.value;
    // console.log("선택값 : " + selectedValue);
    setSelectValue(selectedValue)
    if (selectedValue !== "라임카드를 선택해주세요") {


      const clubInfo = clubdata.find(
        (club: any) => club.club_name === selectedValue
      );
      // console.log("(header) 선택한 클럽정보 : " + JSON.stringify(clubInfo, null, 2))
      if (clubInfo) {
        onClubInfoSelect({
          club_seq: clubInfo.club_seq,
          club_name: clubInfo.club_name,
          valid: clubInfo.valid,
          club_category_seq: clubInfo.club_category_seq,
          agentSeq: clubInfo.agentSeq,
        });
        setselectagent_seq(clubInfo.agentSeq)
        setselectclub_seq(clubInfo.club_seq);
      } else {
        onClubInfoSelect({
          club_seq: 0,
          club_name: "",
          valid: false,
          club_category_seq: 0,
          agentSeq: 0,
        });
        setselectagent_seq(0);
      }
    } else {
      onClubInfoSelect({
        club_seq: 0,
        club_name: "",
        valid: false,
        club_category_seq: 0,
        agentSeq: 0,
      });
      setselectagent_seq(0);
    }
  };

  const handleLogoClick = () => {
    setSelectValue("라임카드를 선택해주세요");
    onClubInfoSelect({
      club_seq: 0,
      club_name: "",
      valid: false,
      club_category_seq: 0,
      agentSeq: 0,
    });
    setselectagent_seq(0);
    onSelectClick("")
  };
  const logOut = () => {
    setUserAtom({
      showModeratorBoard: false,
      showAdminBoard: false,
      currentUser: undefined,
    });

    AuthService.logout();
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100px",
        backgroundColor: "#123758",
        display: "flex",
      }}
    >
      <div
        style={{
          width: width <= 1600 ? 300 : 500,
          display: "flex",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "left",
            alignItems: "center",
            height: "100px",
            marginLeft: width <= 1600 ? "20px" : "50px",
          }}
        >
          <Link to={"/"} className="navbar-brand" onClick={handleLogoClick}>
            <Image
              src="asset/img/Rhymecard_logo.png"
              preview={false}
              width={width <= 1600 ? 100 : 134}
              alt="RhymeCard Logo"
            />
          </Link>
          <div
            style={{
              width: "300px",
              height: "100px",
              alignItems: "center",
              display: "flex",
            }}
          >
            <div
              style={{
                position: "relative",
                display: "inline-block",
                backgroundColor: "white",
                borderRadius: "40px",
                width: width <= 1600 ? 180 : 250,
                height: width <= 1600 ? "40px" : "50px",
                padding: "5px",
                paddingLeft: "5px",
                marginLeft: "30px"
              }}
            >
              <select
                onChange={handleSelectChange}
                defaultValue={clubNameList[0]}
                value={SelectValue}
                style={{
                  width: width <= 1600 ? 180 : 250,
                  fontSize: width <= 1600 ? "13px" : "18px",
                  color: "#123758",
                  border: "none",
                  outline: "none",
                  appearance: "none",
                  background: "transparent",
                  padding: "5px",

                  // paddingRight: "25px",
                }}
              >
                {clubNameList.map((club) => (
                  <option key={club} value={club}>
                    {club}
                  </option>
                ))}
              </select>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "8px",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                }}
              >
                <span
                  style={{
                    display: "inline-block",
                    width: "0",
                    height: "0",
                    borderStyle: "solid",
                    borderWidth: "5px 5px 0",
                    borderColor: "black transparent transparent",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          width: width <= 1600 ? 700 : 1000,
          height: "50px",
          marginTop: "20px",
        }}
      >
        {userAtom.showModeratorBoard && (
          <div
            className="nav-item dropdown"
            style={{
              display: "flex",
              width: "100%",
              height: "100%",
            }}
          >
            {selectagent_seq === 3 && ( //접수
              <div style={{ width: width <= 1600 ? 50 : 150 }}>
                <button
                  onClick={() => onSelectClick("reception")}
                  className={`nav-link ${selectedOption === "reception"}`}
                  style={{
                    width: "100%",
                    border: "none",
                    background: "none",
                    color: "white",
                    cursor: "pointer",
                    fontSize: width <= 1600 ? "18px" : "24px",
                    padding: "10px",
                    margin: "0 5px",
                    whiteSpace: "nowrap",
                    textAlign: "center",
                  }}
                >
                  접수
                </button>
              </div>
            )}

            {selectagent_seq === 1 && ( //대기+접수
              <div style={{ width: width <= 1600 ? 100 : 150, marginLeft: '100px' }}>
                <button
                  onClick={() => onSelectClick("waitlist")}
                  className={`nav-link ${selectedOption === "waitlist" ? "selected" : ""
                    }`}
                  style={{
                    width: "100%",
                    border: "none",
                    background: "none",
                    color: "white",
                    cursor: "pointer",
                    fontSize: width <= 1600 ? "18px" : "24px",
                    padding: "10px",
                    margin: "0 5px",
                    whiteSpace: "nowrap",
                    textAlign: "center",
                  }}
                >
                  접수
                </button>
              </div>
            )}

            {selectagent_seq != 0 && (
              <div style={{ width: width <= 1600 ? 100 : 150 }}>
                <button
                  onClick={() => onSelectClick("notification")}
                  style={{
                    width: "100%",
                    border: "none",
                    background: "none",
                    color: "white",
                    cursor: "pointer",
                    fontSize: width <= 1600 ? "18px" : "24px",
                    padding: "10px",
                    margin: "0 5px",
                    whiteSpace: "nowrap",
                    textAlign: "center",
                  }}
                >
                  새소식
                </button>
              </div>
            )}
            {selectagent_seq != 0 && (
              <div style={{ width: width <= 1600 ? 100 : 150 }}>
                <button
                  // onClick={() => {
                  //   localStorage.setItem("did", selectdid); // localStorage에 값 저장
                  //   localStorage.setItem("clubNumber", selectclub_seq); // localStorage에 값 저장
                  //   localStorage.setItem("selectmemberid", selectmemberid); // localStorage에 값 저장
                  //   // https://club-dev-message.avchain.io/1/159
                  //   window.open(`/1/159`, "_blank");
                  // }}
                  onClick={() => onSelectClick("message")}
                  className={`nav-link ${selectedOption === "message" ? "selected" : ""
                    }`}
                  style={{
                    width: "100%",
                    border: "none",
                    background: "none",
                    color: "white",
                    cursor: "pointer",
                    fontSize: width <= 1600 ? "18px" : "24px",
                    padding: "10px",
                    margin: "0 5px",
                    whiteSpace: "nowrap",
                    textAlign: "center",
                  }}
                >
                  메세지
                </button>
              </div>
            )}
            {selectagent_seq != 0 && (
              <div style={{ width: width <= 1600 ? 100 : 150 }}>
                <button
                  onClick={() => onSelectClick("memberlist")}
                  className={`nav-link ${selectedOption === "memberlist" ? "selected" : ""
                    }`}
                  style={{
                    width: "100%",
                    border: "none",
                    background: "none",
                    color: "white",
                    cursor: "pointer",
                    fontSize: width <= 1600 ? "18px" : "24px",
                    padding: "10px",
                    margin: "0 5px",
                    whiteSpace: "nowrap",
                    textAlign: "center",
                  }}
                >
                  명단
                </button>
              </div>
            )}
            {selectagent_seq != 0 && (
              <div style={{ width: width <= 1600 ? 100 : 150 }}>
                <button
                  onClick={() => onSelectClick("invitation")}
                  className={`nav-link ${selectedOption === "invitation"}`}
                  style={{
                    width: "100%",
                    border: "none",
                    background: "none",
                    color: "white",
                    cursor: "pointer",
                    fontSize: width <= 1600 ? "18px" : "24px",
                    padding: "10px",
                    margin: "0 5px",
                    whiteSpace: "nowrap",
                    textAlign: "center",
                  }}
                >
                  초대
                </button>
              </div>
            )}
            {selectagent_seq === 1 && ( //대기+접수
              <div style={{ width: width <= 1600 ? 100 : 150 }}>
                <button
                  onClick={() => onSelectClick("formlist")}
                  className={`nav-link ${selectedOption === "waitlist" ? "selected" : ""
                    }`}
                  style={{
                    width: "100%",
                    border: "none",
                    background: "none",
                    color: "white",
                    cursor: "pointer",
                    fontSize: width <= 1600 ? "18px" : "24px",
                    padding: "10px",
                    margin: "0 5px",
                    whiteSpace: "nowrap",
                    textAlign: "center",
                  }}
                >
                  서식
                </button>
              </div>
            )}
            {selectagent_seq === 1 && ( //대기+접수
              <div style={{ width: width <= 1600 ? 100 : 150 }}>
                <button
                  onClick={() => onSelectClick("reservationlist")}
                  className={`nav-link ${selectedOption === "waitlist" ? "selected" : ""
                    }`}
                  style={{
                    width: "100%",
                    border: "none",
                    background: "none",
                    color: "white",
                    cursor: "pointer",
                    fontSize: width <= 1600 ? "18px" : "24px",
                    padding: "10px",
                    margin: "0 5px",
                    whiteSpace: "nowrap",
                    textAlign: "center",
                  }}
                >
                  예약
                </button>
              </div>
            )}
            {/* {selectagent_seq} */}

            {selectagent_seq === 2 && (
              <div style={{ width: width <= 1600 ? 100 : 150 }}>
                <button
                  onClick={() => onSelectClick("dueslist")}
                  className={`nav-link ${selectedOption === "dueslist" ? "selected" : ""
                    }`}
                  style={{
                    width: "100%",
                    border: "none",
                    background: "none",
                    color: "white",
                    cursor: "pointer",
                    fontSize: width <= 1600 ? "18px" : "24px",
                    padding: "10px",
                    margin: "0 5px",
                    whiteSpace: "nowrap",
                    textAlign: "center",
                  }}
                >
                  회비
                </button>
              </div>
            )}

            {selectagent_seq === 1 && (
              <div style={{ width: "150px" }}>
                <button
                  onClick={() => {
                    if (selectedDeviceName === null || selectedDeviceName === "" || selectedDeviceName === undefined) {
                      alert("라임카드앱에서 기기등록을 먼저해주세요");
                    } else {
                      localStorage.setItem("did", selectdid);
                      localStorage.setItem("clubNumber", selectclub_seq);
                      localStorage.setItem("selectmemberid", selectmemberid);
                      localStorage.setItem("selectedDeviceName", selectedDeviceName);
                      localStorage.setItem("selectmemberidsoket", selectmemberidsoket);
                      localStorage.setItem("selectdeviceid", selectdeviceid);
                      // console.log("넘기는 진료과 정보 :" + selectdid);
                      // console.log("넘기는 진료과 정보 :" + selectclub_seq);
                      // console.log("넘기는 진료과 정보 :" + selectmemberid);
                      // console.log("넘기는 진료과 정보 :" + selectedDeviceName);
                      // console.log("넘기는 진료과 정보 :" + selectmemberidsoket);
                      // console.log("넘기는 진료과 정보 :" + selectdeviceid);

                      if (waitinput !== null) {
                        waitinput.close();
                        setwaitinput(null)
                        const waitinputt = window.open(`/Waitinput/${selectclub_seq}`, "_blank");
                        setwaitinput(waitinputt)
                      } else {
                        const waitinputt = window.open(`/Waitinput/${selectclub_seq}`, "_blank");
                        setwaitinput(waitinputt)
                      }
                    }
                  }}
                  className={`nav-link ${selectedOption === "Waitinput" ? "selected" : ""
                    }`}
                  style={{
                    width: "100%",
                    border: "none",
                    background: "none",
                    color: "white",
                    cursor: "pointer",
                    fontSize: width <= 1600 ? "18px" : "24px",
                    padding: "10px",
                    margin: "0 5px",
                    whiteSpace: "nowrap",
                    textAlign: "center",
                  }}
                >
                  핸드폰 접수
                </button>
              </div>
            )}

            {selectagent_seq === 1 && (
              <div style={{ width: "150px" }}>
                <button
                  onClick={() => {

                    if (selectedDeviceName === null || selectedDeviceName === "" || selectedDeviceName === undefined) {
                      alert("라임카드앱에서 기기등록을 먼저해주세요");
                    } else {
                      localStorage.setItem("did", selectdid); // localStorage에 값 저장
                      localStorage.setItem("clubNumber", selectclub_seq); // localStorage에 값 저장
                      localStorage.setItem("selectmemberid", selectmemberid); // localStorage에 값 저장
                      localStorage.setItem("selectedDeviceName", selectedDeviceName); // localStorage에 값 저장
                      localStorage.setItem("selectmemberidsoket", selectmemberidsoket); // localStorage에 값 저장

                      // console.log("넘기는 진료과 정보 :" + selectdid);
                      // console.log("넘기는 진료과 정보 :" + selectclub_seq);
                      // console.log("넘기는 진료과 정보 :" + selectmemberid);
                      // console.log("넘기는 진료과 정보 :" + selectedDeviceName);
                      // console.log("넘기는 진료과 정보 :" + selectmemberidsoket);

                      if (waitview !== null) {
                        waitview.close();
                        setwaitview(null)
                        const waitvieww = window.open("/Waitview", "_blank");
                        setwaitview(waitvieww)
                      } else {
                        const waitvieww = window.open("/Waitview", "_blank");
                        setwaitview(waitvieww)
                      }
                    }
                  }}
                  className={`nav-link ${selectedOption === "Waitinput" ? "selected" : ""
                    }`}
                  style={{
                    width: "100%",
                    border: "none",
                    background: "none",
                    color: "white",
                    cursor: "pointer",
                    fontSize: width <= 1600 ? "18px" : "24px",
                    padding: "10px",
                    margin: "0 5px",
                    whiteSpace: "nowrap",
                    textAlign: "center",
                  }}
                >
                  대기화면
                </button>

              </div>
            )}
  {/* {selectagent_seq} */}
            {selectagent_seq === 4 && (
              <div style={{ width: width <= 1600 ? 100 : 150 }}>
                <button
                  onClick={() => onSelectClick("FABRestaurant")}
                  className={`nav-link ${selectedOption === "waitlist" ? "selected" : ""
                    }`}
                  style={{
                    width: "100%",
                    border: "none",
                    background: "none",
                    color: "white",
                    cursor: "pointer",
                    fontSize: width <= 1600 ? "18px" : "24px",
                    padding: "10px",
                    margin: "0 5px",
                    whiteSpace: "nowrap",
                    textAlign: "center",
                  }}
                >
                  F&B
                </button>
              </div>
            )}

            {/* {selectagent_seq !== 1 && selectagent_seq !== 4 && (
              <div style={{ width: width <= 1600 ? 100 : 150 }}>
                <button
                  onClick={() => onSelectClick("FABCompany")}
                  className={`nav-link ${selectedOption === "waitlist" ? "selected" : ""
                    }`}
                  style={{
                    width: "100%",
                    border: "none",
                    background: "none",
                    color: "white",
                    cursor: "pointer",
                    fontSize: width <= 1600 ? "18px" : "24px",
                    padding: "10px",
                    margin: "0 5px",
                    whiteSpace: "nowrap",
                    textAlign: "center",
                  }}
                >
                  F&B
                </button>
              </div>
            )} */}
          </div>

        )}
      </div>
      <div style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
        {userAtom.currentUser ? (
          <div className="navbar-nav ms-auto">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "auto",
                whiteSpace: "nowrap",
                fontSize: "20px",
                textAlign: "center",
                margin: "10px"
              }}
            >
              <div style={{ color: "white", margin: "10px" }}>
                {profileImage ? (
                  <Image
                    src={profileImage}
                    preview={false}
                    width={63}
                    style={{
                      borderRadius: "50%",
                      width: 63,
                      height: 63,
                      marginBottom: "10px",
                      color: "white",
                      marginLeft: "-30px"

                    }}
                  />
                ) : (
                  <Image
                    src="asset/img/ic_person.png"
                    preview={false}
                    width={63}
                    style={{
                      borderRadius: "50%",
                      width: 63,
                      height: 63,
                      marginBottom: "10px",
                      color: "white",
                      backgroundColor: "white", // Set background color to white
                      marginLeft: "-30px"
                    }}
                  />
                )}

                {userAtom.currentUser.name}
              </div>
              <div
                className="nav-item"
                style={{ color: "white" }}
              >
                <a
                  href="/login"
                  className="nav-link"
                  onClick={logOut}
                  style={{
                    textDecoration: "underline",
                    margin: "20px",
                    fontSize: width <= 1600 ? "15px" : "20px",
                  }}
                >
                  로그아웃
                </a>
              </div>
            </div>
          </div>
        ) : (
          <div className="navbar-nav ms-auto"></div>
        )}
      </div>
    </div>
  );
}

